import { Avatar, Checkbox, TableCell, TableRow, Tooltip, Typography, useTheme } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React from "react";
import clsx from "clsx";
import { LocationOnOutlined, PriorityHigh, Schedule } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useRowStyles } from "../../../components/CustomRowStyles";

export const SurveyingMomentCustomRow = ({item,onRowClick,handleCheckboxChange,selectedCheckBoxes=[]}) => {
    const classes = { ...useRowStyles(), ...useStyles() };
    const theme = useTheme();
    const { t } = useTranslation();
    
    return (
        <React.Fragment >
                <TableRow onClick={(e) => {
                    e.stopPropagation();
                    onRowClick(item);
                }}  className={clsx([classes.customGridRow, classes.row])}
                sx={{padding: theme.spacing(0, 1),}}

                >
                    <TableCell >
                        <div className={classes.customSmallDeviceRowContainer} style={{ padding: 0 }}>
                            <div className={classes.verticallyCenterContainer}>
                                <div className={classes.relativeContainer}>
                                    <Avatar
                                        className={clsx(classes.thumbnail, classes.avatarThumbnail, 'thumb-exception')} 
                                        >
                                        {isNaN(item.object) ? item.object[0] : item.object}
                                    </Avatar>
                                </div>
                            </div>
                            <div className={classes.columnContainer}>
                                <div className={clsx(classes.detailContainer, classes.descriptionContainer, classes.maxWidth_100)}>
                                    <div>
                                        <Typography className={clsx(classes.requestTitle, classes.grow)}>
                                            {item.name && item.name}
                                        </Typography>
                                    </div>
                                    <div>
                                        <Typography noWrap className={classes.flexContainer}>
                                            {item.hasUpdate && (
                                                <>
                                                    <Tooltip title={<Typography>{t("general.actionRequired")}</Typography>}>
                                                        <PriorityHigh color="secondary" fontSize="small" size="small" />
                                                    </Tooltip>
                                                    <div className={classes.borderRight} />
                                                </>
                                            )}
                                            {item.overdue ? (
                                                <>
                                                    <Tooltip title={<Typography>{t("general.tooLate")}</Typography>}>
                                                        <Schedule fontSize="small" size="small" color="error" className={classes.marginRight_5} />
                                                    </Tooltip>
                                                    <div className={classes.borderRight} />
                                                </>
                                            ) : item.is48HoursReminder ? (
                                                <>
                                                    <Tooltip title={<Typography>{t("general.48hours")}</Typography>}>
                                                        <Schedule fontSize="small" size="small" className={clsx(classes.warning, classes.marginRight_5)} />
                                                    </Tooltip>
                                                    <div className={classes.borderRight} />
                                                </>
                                            ) : ("")}
                                            <Checkbox size="small" className={clsx(classes.customCheckbox, classes.noPaddingContainer)} 
                                            checked={selectedCheckBoxes.includes(item.surveyingMomentId)}
                                             color='primary'
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={() => {
                                                handleCheckboxChange(item.surveyingMomentId);
                                            }}
                                               />
                                        </Typography>
                                    </div>
                                </div>
                                <div className={clsx(classes.detailContainer, classes.descriptionContainer, classes.maxWidth_100)}>
                                    <div>
                                        <Typography className={classes.requestTypeLabel}>
                                            {`${item.completedAssignments}/${item.totalAssignments} ${t("wkb.assignments.label")}`}
                                        </Typography>
                                    </div>
                                    <div>
                                        <Typography
                                            className={classes.requestStatusLabel}
                                            style={{ color: item.completed ? "#2DA800" : item.overdue ? "#f00" : "#5C5C5C" }}>
                                            {t(item.internalStatusPlainText)}
                                        </Typography>
                                    </div>
                                </div>
                                <div className={clsx(classes.detailContainer, classes.descriptionContainer, classes.maxWidth_100)}>
                                    <div>
                                        <Typography className={classes.requestBuildingLabel}>
                                            <div className={classes.locationIconContainer}>
                                                <LocationOnOutlined className={classes.locationIcon} />
                                            </div>
                                            <span>
                                                {item.object}
                                            </span>
                                        </Typography>
                                    </div>
                                    <div>
                                        <Typography className={classes.requestBuildingLabel} >
                                           {item.handlingPeriod }
                                        </Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TableCell>
                </TableRow>
        </React.Fragment>
    );
};

const useStyles = makeStyles(theme => ({
    grow: {
        flexGrow: 1
    },
    descriptionContainer: {
        flexDirection: "row"
    },
    offlineIconContainer: {
        position: "absolute",
        right: 0,
        top: 0
    },
    offlineIcon: {
        fontSize: 14,
        fill: theme.palette.common.white
    },
    avatarThumbnail: {
        background: theme.palette.primary.main,
        fontSize: 15,
        fontWeight: 'bold',
        borderRadius: 6,
        boxShadow: "0px 0px 3px #eee"
    },
    imageBadgeContainer1: {
        bottom: 0,
        right: 0,
        borderRadius: 0,
        borderBottomRightRadius: 6,
        borderTopLeftRadius: 6,
        fontSize: 10,
        fontWeight: "bold",
        textTransform: "capitalize"
    },
     row: {
    "& td": {
      padding: "2px",
      width: "100%",
    },
    display: "flex",
    },
    overflowEllipse: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        "-webkit-line-clamp": 1,
        "-webkit-box-orient": "vertical",
    }
}));